import React from 'react';
import { Redirect } from 'react-router-dom';
import { routePaths } from '../../routePaths';

const ReportsPage = () => (
    <Redirect to={routePaths.dashboard} />
);

export default ReportsPage;